import {makeStyles} from "@material-ui/core/styles";
import { colors } from '../../shared/colors';

const useStyles = makeStyles((theme) => ({
    root:{
        display: 'flex',
        flexDirection: 'column'
    },
    headerTop:{
        backgroundColor: colors.californiaBlue,
        height: '3rem',
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down(760)]:{
            height: '7vh',
        },
        [theme.breakpoints.down(450)]:{
            height: '16vh',
        },
        [theme.breakpoints.down(330)]:{
            height: '12vh',
        }
    },
    headerBottom:{
        display: 'flex',
        flexDirection: 'row',
        marginTop: '1rem',
        borderBottom: `5px solid ${colors.dhcsOrange}`,
        paddingLeft: '6rem',
        paddingRight: '3rem',
        [theme.breakpoints.down(961)]: {
            padding: '0 0 0 2rem'
        },
        [theme.breakpoints.down(440)]: {
            padding: '0'
        },
    },
    headerBottomDHCSLogo:{
        paddingBottom: '0.5rem',
        [theme.breakpoints.down(440)]: {
            paddingLeft: '0',
            transform: 'scale(0.7)'
        }
    },
    headerBottomNavLinksWrapper:{
        display: 'flex',
        flexGrow: 1,
    },
    headerBottomNavLinksContent:{
        paddingTop: '1rem',
        paddingRight: '3rem',
        justifyContent: 'flex-end'
    },
    caLogoWrapper:{
        paddingTop: '1rem',
        paddingLeft: '0.7rem',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    caLogo:{
        '& > a:focus-visible': {
            outline: `3px solid ${colors.dhcsTeal}`
          }
    },
    dhcsLogo:{
        width: '350px',
        height: 'auto',
        [theme.breakpoints.down(730)]:{
            paddingTop: '0'
        },
        [theme.breakpoints.down(961)]:{
            paddingLeft: '3rem'
        }
    },
    personaIcon: {
        fontSize: "2rem",
        paddingBottom: '0.3rem',
        paddingRight: '1rem',
    },
    contactLink: {
        color: '#fff',
        fontWeight: 'bold',
        '&:hover': {
            color: colors.californiaYellow
        },
        '&:focus-visible': {
            color: colors.californiaYellow,
            outline: `2px solid ${colors.dhcsWhite}`,
            outlineOffset: '1px'
        }
    },
    npi: {
        fontWeight: 'bold'
    },
    npiWrapper: {
        paddingBottom: '0.3rem',
        paddingRight: '1rem',
    },
    contactLinkWrapper: {
        paddingBottom: '0.3rem',
        paddingRight: '1rem',
    },
    langWrapper:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        paddingBottom: '0.3rem',
        paddingRight: '7vw'
    },

    headerTypography: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        color: '#fff',
        fontSize: '14px'
    },
    homeLink: {
        color: '#fff',
        fontWeight: 550,
        '&:hover': {
            color: colors.californiaYellow,
            textDecoration: 'none'
        },
        '&:focus-visible': {
            color: colors.californiaYellow,
            outline: `2px solid ${colors.dhcsWhite}`,
            outlineOffset: '1px'
        }
    },
    homeRedirectIcon: {
        paddingBottom: '0.5rem',
        transform: 'scale(0.8)'
    },
    homeLinkWrapper: {
        paddingRight: '1rem'
    },
    logoutButton: {
        display: 'grid',
        alignSelf: 'baseline',
        alignItems: 'center',
        textTransform: 'none',
        '&:focus-visible': {
            outline: `3px solid ${colors.dhcsTeal}`
        }
    },
    logoutIcon: {
        width: '40px',
        margin: '0 auto'
    },
    logoutLabel: {
        fontFamily: 'Segoe UI, Noto Sans, sans-serif',
        fontSize: '16px'
    }
}))
export default useStyles;
